const faBCContacts = {
  prefix: 'fas',
  iconName: 'bc-contacts',
  icon: [
    24,
    24,
    [],
    'f0001',
    'M11 3C9.34315 3 8 4.34315 8 6V8C8 9.65685 9.34315 11 11 11H13C14.6569 11 16 9.65685 16 8V6C16 4.34315 14.6569 3 13 3H11Z M6 15C3.79086 15 2 16.7909 2 19V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V19C22 16.7909 20.2091 15 18 15H6Z'
  ]
}

const faBCData = {
  prefix: 'fas',
  iconName: 'bc-data',
  icon: [
    24,
    24,
    [],
    'f0002',
    'M21.7634 10.0016C21.824 10.5506 21.3704 11 20.8181 11H14C13.4477 11 13 10.5523 13 10V3.02186C13 2.46182 13.4619 2.0053 14.017 2.07919C18.0952 2.62202 21.3102 5.89577 21.7634 10.0016Z M2 12.9091C2 7.91871 6.0211 3.86745 11 3.81867V11.0001C11 12.1046 11.8954 13.0001 13 13.0001H20.1814C20.1326 17.979 16.0813 22 11.0909 22C6.07014 22 2 17.9299 2 12.9091Z'
  ]
}

const faBCWorkflow = {
  prefix: 'fas',
  iconName: 'bc-workflow',
  icon: [
    24,
    24,
    [],
    'f0003',
    'M14.6455 8.55042C14.4318 8.18421 14.488 7.72955 14.6792 7.35115C14.8844 6.94509 15 6.48604 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C12.3387 9 12.6757 9.14298 12.8463 9.4355L15.551 14.072C15.6901 14.3105 15.9963 14.3911 16.2348 14.2519L17.0986 13.7481C17.3371 13.6089 17.4177 13.3028 17.2785 13.0642L14.6455 8.55042Z M19 21C20.6569 21 22 19.6569 22 18C22 16.3431 20.6569 15 19 15C17.9453 15 17.0178 15.5442 16.4828 16.3672C16.2519 16.7226 15.8873 17 15.4635 17H10.5C10.2239 17 10 17.2239 10 17.5V18.5C10 18.7761 10.2239 19 10.5 19H15.4635C15.8873 19 16.2519 19.2774 16.4828 19.6328C17.0178 20.4558 17.9453 21 19 21Z M8 18C8 19.6569 6.65685 21 5 21C3.34315 21 2 19.6569 2 18C2 16.3431 3.34315 15 5 15C5.33866 15 5.67571 14.857 5.84635 14.5645L8.55096 9.92802C8.6901 9.6895 8.99626 9.60893 9.23479 9.74807L10.0986 10.2519C10.3371 10.3911 10.4177 10.6972 10.2785 10.9358L7.64546 15.4496C7.43184 15.8158 7.48803 16.2705 7.67923 16.6489C7.88441 17.0549 8 17.514 8 18Z'
  ]
}

const faBCDocuments = {
  prefix: 'fas',
  iconName: 'bc-documents',
  icon: [
    24,
    24,
    [],
    'f0004',
    'M3 6C3 4.89543 3.89543 4 5 4H10C11.1046 4 12 4.89543 12 6V8H19C20.1046 8 21 8.89543 21 10V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V6Z M21 6V6.53513C20.4116 6.19479 19.7285 6 19 6H14C14 5.27142 13.8052 4.58835 13.4648 4H19C20.1045 4 21 4.89542 21 6Z'
  ]
}

const faBCUsers = {
  prefix: 'fas',
  iconName: 'bc-users',
  icon: [
    24,
    24,
    [],
    'f0005',
    'M6 7C6 5.89543 6.89543 5 8 5H10C11.1046 5 12 5.89543 12 7V9C12 10.1046 11.1046 11 10 11H8C6.89543 11 6 10.1046 6 9V7Z M2 16C2 14.8954 2.89543 14 4 14H14C15.1046 14 16 14.8954 16 16V18.4C16 18.7314 15.7314 19 15.4 19H2.6C2.26863 19 2 18.7314 2 18.4V16Z M15 9.5C15 8.67157 15.6716 8 16.5 8H17.5C18.3284 8 19 8.67157 19 9.5V10.5C19 11.3284 18.3284 12 17.5 12H16.5C15.6716 12 15 11.3284 15 10.5V9.5Z M18 18H21.4C21.7314 18 22 17.7314 22 17.4V16.4C22 15.0745 20.9255 14 19.6 14H17.2361C17.7112 14.5308 18 15.2316 18 16V18Z'
  ]
}

const faBCAllModules = {
  prefix: 'fas',
  iconName: 'bc-all-modules',
  icon: [
    24,
    24,
    [],
    'f0006',
    'M4.5 3C3.67157 3 3 3.67157 3 4.5V9.5C3 10.3284 3.67157 11 4.5 11H9.5C10.3284 11 11 10.3284 11 9.5V4.5C11 3.67157 10.3284 3 9.5 3H4.5Z M14.5 3C13.6716 3 13 3.67157 13 4.5V9.5C13 10.3284 13.6716 11 14.5 11H19.5C20.3284 11 21 10.3284 21 9.5V4.5C21 3.67157 20.3284 3 19.5 3H14.5Z M3 14.5C3 13.6716 3.67157 13 4.5 13H9.5C10.3284 13 11 13.6716 11 14.5V19.5C11 20.3284 10.3284 21 9.5 21H4.5C3.67157 21 3 20.3284 3 19.5V14.5Z M14.5 13C13.6716 13 13 13.6716 13 14.5V19.5C13 20.3284 13.6716 21 14.5 21H19.5C20.3284 21 21 20.3284 21 19.5V14.5C21 13.6716 20.3284 13 19.5 13H14.5Z'
  ]
}

const faBCSidebarToggle = {
  prefix: 'fas',
  iconName: 'bc-sidebar-toggle',
  icon: [
    20,
    20,
    [],
    'f0007',
    'M2 5H9V3H2V5Z M2 11H9V9H2V11Z M2 17V15H16V17H2Z M12.7773 3.51823C12.4451 3.29672 12 3.53491 12 3.93426V10.0657C12 10.4651 12.4451 10.7033 12.7773 10.4818L17.376 7.41603C17.6728 7.21811 17.6728 6.78189 17.376 6.58398L12.7773 3.51823Z'
  ]
}

const faBCThreeBars = {
  prefix: 'fas',
  iconName: 'bc-three-bars',
  icon: [
    20,
    20,
    [],
    'f007',
    'M20 1C20 0.447715 19.5523 0 19 0H1C0.447716 0 0 0.447715 0 1V4C0 4.55228 0.447716 5 1 5H19C19.5523 5 20 4.55228 20 4V1ZM20 8.5C20 7.94772 19.5523 7.5 19 7.5H1C0.447716 7.5 0 7.94772 0 8.5V11.5C0 12.0523 0.447716 12.5 1 12.5H19C19.5523 12.5 20 12.0523 20 11.5V8.5ZM19 15C19.5523 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H1C0.447716 20 0 19.5523 0 19V16C0 15.4477 0.447716 15 1 15H19Z'
  ]
}

const faBCTwoBars = {
  prefix: 'fas',
  iconName: 'bc-two-bars',
  icon: [
    20,
    20,
    [],
    'f008',
    'M1 0C0.447715 0 0 0.447715 0 1V7.75C0 8.30229 0.447715 8.75 1 8.75H19C19.5523 8.75 20 8.30229 20 7.75V1C20 0.447715 19.5523 0 19 0H1ZM1 11.25C0.447715 11.25 0 11.6977 0 12.25V19C0 19.5523 0.447715 20 1 20H19C19.5523 20 20 19.5523 20 19V12.25C20 11.6977 19.5523 11.25 19 11.25H1Z'
  ]
}

const faBCHExpand = {
  prefix: 'fas',
  iconName: 'bc-h-expand',
  icon: [
    20,
    20,
    [],
    'f009',
    'M19.0238 0.0289307C19.5761 0.0289307 20.0238 0.476646 20.0238 1.02893C20.0238 1.58122 19.5761 2.02893 19.0238 2.02893H17.1677C16.6154 2.02893 16.1677 2.47665 16.1677 3.02893V17.0238C16.1677 17.5761 16.6154 18.0238 17.1677 18.0238H19.0238C19.5761 18.0238 20.0238 18.4715 20.0238 19.0238C20.0238 19.5761 19.5761 20.0238 19.0238 20.0238H17.1677C15.5109 20.0238 14.1677 18.6806 14.1677 17.0238V3.02893C14.1677 1.37208 15.5109 0.0289307 17.1677 0.0289307H19.0238ZM6.87671 5.59139C7.26723 5.20087 7.26723 4.5677 6.87671 4.17718C6.48618 3.78665 5.85302 3.78665 5.46249 4.17718L0.321092 9.31856C0.133555 9.5061 0.0281982 9.76046 0.0281982 10.0257C0.0281982 10.2909 0.133555 10.5452 0.321092 10.7328L5.46249 15.8742C5.85302 16.2647 6.48618 16.2647 6.87671 15.8742C7.26723 15.4836 7.26723 14.8505 6.87671 14.46L3.44242 11.0257H10.6683C11.2206 11.0257 11.6683 10.578 11.6683 10.0257C11.6683 9.47339 11.2206 9.02567 10.6683 9.02567H3.44242L6.87671 5.59139Z'
  ]
}

const faBCHCollapse = {
  prefix: 'fas',
  iconName: 'bc-h-collapse',
  icon: [
    20,
    20,
    [],
    'f010',
    'M19.0238 0.0289307C19.5761 0.0289307 20.0238 0.476646 20.0238 1.02893C20.0238 1.58122 19.5761 2.02893 19.0238 2.02893H17.1677C16.6155 2.02893 16.1677 2.47664 16.1677 3.02893V17.0238C16.1677 17.5761 16.6155 18.0238 17.1677 18.0238H19.0238C19.5761 18.0238 20.0238 18.4715 20.0238 19.0238C20.0238 19.5761 19.5761 20.0238 19.0238 20.0238H17.1677C15.5109 20.0238 14.1677 18.6806 14.1677 17.0238V3.02893C14.1677 1.37208 15.5109 0.0289307 17.1677 0.0289307H19.0238ZM4.81981 14.4599C4.42929 14.8504 4.42929 15.4836 4.81981 15.8741C5.21033 16.2646 5.8435 16.2646 6.23402 15.8741L11.3754 10.7327C11.563 10.5452 11.6683 10.2908 11.6683 10.0256C11.6683 9.76039 11.563 9.50604 11.3754 9.3185L6.23403 4.17711C5.8435 3.78659 5.21034 3.78659 4.81981 4.17711C4.42929 4.56764 4.42929 5.2008 4.81981 5.59133L8.2541 9.02561L1.0282 9.02561C0.475913 9.02561 0.0281983 9.47332 0.0281982 10.0256C0.0281982 10.5779 0.475913 11.0256 1.0282 11.0256L8.2541 11.0256L4.81981 14.4599Z'
  ]
}

const faBCAccess = {
  prefix: 'fas',
  iconName: 'bc-access',
  icon: [
    24,
    24,
    [],
    'f011',
    'M6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V11H19C20.1046 11 21 11.8954 21 13V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V13C3 11.8954 3.89543 11 5 11H6V8ZM16 8V11H8V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8ZM14 15C14 15.7403 13.5978 16.3866 13 16.7324V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V16.7324C10.4022 16.3866 10 15.7403 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15Z'
  ]
}

const faBCClaims = {
  prefix: 'fas',
  iconName: 'bc-claims',
  icon: [
    24,
    24,
    [],
    'f012',
    'M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H9C8.44772 4 8 3.55228 8 3Z M6 3H5C3.89543 3 3 3.89543 3 5V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V5C21 3.89543 20.1046 3 19 3H18V4C18 5.10457 17.1046 6 16 6H8C6.89543 6 6 5.10457 6 4V3ZM13.2285 8.89719L8.15985 13.628C7.82809 13.9376 8.0472 14.4935 8.50101 14.4935H11.5182L10.4244 17.5561C10.2482 18.0496 10.8533 18.4474 11.2364 18.0898L16.3051 13.359C16.6369 13.0494 16.4178 12.4935 15.964 12.4935H12.9468L14.0406 9.43089C14.2168 8.93738 13.6117 8.53963 13.2285 8.89719Z'
  ]
}

const faBCDashboard = {
  prefix: 'fas',
  iconName: 'bc-dashboard',
  icon: [
    24,
    24,
    [],
    'f013',
    'M17.8813 21C18.6873 21 19.4771 20.6889 19.965 20.0473C21.242 18.3679 22 16.2725 22 14C22 8.47715 17.5228 4 12 4C6.47715 4 2 8.47715 2 14C2 16.2725 2.75802 18.3679 4.03501 20.0473C4.52286 20.6889 5.31272 21 6.11871 21H17.8813ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8ZM7 10.5C7.55228 10.5 8 10.0523 8 9.5C8 8.94772 7.55228 8.5 7 8.5C6.44772 8.5 6 8.94772 6 9.5C6 10.0523 6.44772 10.5 7 10.5ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16ZM19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14C18.4477 14 18 14.4477 18 15C18 15.5523 18.4477 16 19 16ZM17.294 9.04392C17.4453 9.09025 17.5877 9.17324 17.7073 9.29289C18.0979 9.68342 18.0979 10.3166 17.7073 10.7071L14.7077 13.7067C14.8951 14.0983 15 14.5369 15 15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C12.4632 12 12.9019 12.105 13.2936 12.2924L16.2802 9.30578C16.4621 9.11726 16.7174 9 17 9C17.0173 9 17.0344 9.00044 17.0515 9.0013C17.1355 9.00556 17.2167 9.02018 17.294 9.04392Z'
  ]
}

const faBCIntegrations = {
  prefix: 'fas',
  iconName: 'bc-integrations',
  icon: [
    24,
    24,
    [],
    'f014',
    'M9 4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4V5C15 5.55228 15.4477 6 16 6H19C20.1046 6 21 6.89543 21 8V10.5C21 10.7761 20.7761 11 20.5 11H19C17.3431 11 16 12.3431 16 14C16 15.6569 17.3431 17 19 17H20.5C20.7761 17 21 17.2239 21 17.5V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V8C3 6.89543 3.89543 6 5 6H8C8.55228 6 9 5.55228 9 5V4Z'
  ]
}

const faBCLines = {
  prefix: 'fas',
  iconName: 'bc-lines',
  icon: [
    24,
    24,
    [],
    'f015',
    'M3 4C3 2.89543 3.89543 2 5 2H20C20.5523 2 21 2.44772 21 3V15C21 15.5523 20.5523 16 20 16H6.5C5.67157 16 5 16.6716 5 17.5V18.5C5 19.3284 5.67157 20 6.5 20H21V21C21 21.5523 20.5523 22 20 22H5C3.89543 22 3 21.1046 3 20V4ZM6 7C6 6.44772 6.44772 6 7 6H8C8.55228 6 9 6.44772 9 7C9 7.55228 8.55228 8 8 8H7C6.44772 8 6 7.55228 6 7ZM11 7C11 6.44772 11.4477 6 12 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H12C11.4477 8 11 7.55228 11 7ZM6 11C6 10.4477 6.44772 10 7 10H8C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12H7C6.44772 12 6 11.5523 6 11ZM11 11C11 10.4477 11.4477 10 12 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H12C11.4477 12 11 11.5523 11 11Z'
  ]
}

const faBCNotes = {
  prefix: 'fas',
  iconName: 'bc-notes',
  icon: [
    24,
    24,
    [],
    'f016',
    'M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4L20.9856 14.7861C20.9854 14.8963 20.8963 14.9856 20.7861 14.9859L16 15C14.8954 15 14 15.8954 14 17V21.8C14 21.9105 13.9105 22 13.8 22H5C3.89543 22 3 21.1046 3 20V4ZM7 8C7 7.44772 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8ZM7 12C7 11.4477 7.44772 11 8 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12Z M17 17C16.4477 17 16 17.4477 16 18V21.5172C16 21.6953 16.2154 21.7846 16.3414 21.6586L20.6586 17.3414C20.7846 17.2154 20.6953 17 20.5172 17H17Z'
  ]
}

const faBCPolicies = {
  prefix: 'fas',
  iconName: 'bc-policies',
  icon: [
    24,
    24,
    [],
    'f017',
    'M11.1215 1.42946L3.12158 5.34057C2.43523 5.67612 1.99348 6.37717 2.02631 7.14045C2.35725 14.8358 5.78542 18.6689 10.8986 22.2485C11.56 22.7116 12.4399 22.7116 13.1013 22.2486C18.2146 18.6689 21.6427 14.8358 21.9737 7.14045C22.0065 6.37718 21.5648 5.67612 20.8784 5.34057L12.8784 1.42946C12.3241 1.15848 11.6758 1.15848 11.1215 1.42946ZM16.7894 9.61393C17.1284 9.17799 17.0499 8.54971 16.614 8.21064C16.178 7.87157 15.5497 7.95011 15.2107 8.38605L11.3023 13.4111L9.76475 11.5864C9.40888 11.1641 8.77802 11.1102 8.35567 11.466C7.93332 11.8219 7.87943 12.4528 8.23529 12.8751L10.5686 15.6443C10.763 15.8751 11.0513 16.0057 11.3529 15.9998C11.6546 15.9939 11.9375 15.8521 12.1227 15.6139L16.7894 9.61393Z'
  ]
}

const faBCQuote = {
  prefix: 'fas',
  iconName: 'bc-quote',
  icon: [
    24,
    24,
    [],
    'f018',
    'M3 20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20L20.9855 7.21375C20.9854 7.10367 20.8963 7.01438 20.7863 7.01398L17 7C15.8954 7 15 6.10457 15 5V1.2C15 1.08954 14.9105 1 14.8 1H5C3.89543 1 3 1.89543 3 3V20ZM12.8183 16.2793V17.5714C12.8183 17.8082 12.6353 18 12.4093 18H11.5912C11.3652 18 11.1822 17.8082 11.1822 17.5714V16.2702C10.6049 16.2391 10.0435 16.028 9.57827 15.6621C9.37887 15.5052 9.36864 15.1923 9.54913 15.0118L10.1499 14.4113C10.2915 14.2698 10.5022 14.2634 10.6678 14.3721C10.8657 14.5018 11.0902 14.5714 11.3233 14.5714H12.7605C13.0929 14.5714 13.3639 14.2543 13.3639 13.8648C13.3639 13.5461 13.1793 13.2654 12.9155 13.1829L10.6147 12.4596C9.66417 12.1607 9 11.205 9 10.1352C9 8.82161 9.97401 7.75446 11.1817 7.72071V6.42857C11.1817 6.19179 11.3647 6 11.5907 6H12.4088C12.6348 6 12.8178 6.19179 12.8178 6.42857V7.72982C13.3951 7.76089 13.9565 7.97143 14.4217 8.33786C14.6211 8.49482 14.6314 8.80768 14.4509 8.98821L13.8501 9.58875C13.7085 9.73018 13.4978 9.73661 13.3322 9.62786C13.1343 9.49768 12.9098 9.42857 12.6767 9.42857H11.2395C10.9071 9.42857 10.6361 9.74571 10.6361 10.1352C10.6361 10.4539 10.8207 10.7346 11.0845 10.8171L13.3853 11.5404C14.3358 11.8393 15 12.795 15 13.8648C15 15.1789 14.026 16.2455 12.8183 16.2793Z M17 4C17 4.55228 17.4477 5 18 5H20.5172C20.6953 5 20.7846 4.78457 20.6586 4.65858L17.3414 1.34142C17.2154 1.21543 17 1.30466 17 1.48284V4Z'
  ]
}

const faBCRules = {
  prefix: 'fas',
  iconName: 'bc-rules',
  icon: [
    24,
    24,
    [],
    'f019',
    'M13.0392 2.2765C12.3962 1.90783 11.6038 1.90783 10.9608 2.2765L4.03923 6.24458C3.39615 6.61325 3 7.29458 3 8.03193V15.9681C3 16.7054 3.39615 17.3868 4.03923 17.7554L10.9608 21.7235C11.6038 22.0922 12.3962 22.0922 13.0392 21.7235L19.9608 17.7554C20.6038 17.3868 21 16.7054 21 15.9681V8.03193C21 7.29458 20.6038 6.61325 19.9608 6.24458L13.0392 2.2765ZM10.9459 18.2094C11.3802 18.5352 12 18.2253 12 17.6824V17H13C15.7614 17 18 14.7614 18 12V11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11V12C16 13.6569 14.6569 15 13 15H12V14.3177C12 13.7748 11.3802 13.4649 10.9459 13.7906L8 16L10.9459 18.2094ZM13.0541 5.79059C12.6198 5.46484 12 5.77474 12 6.31764V7H11C8.23858 7 6 9.23857 6 12V13C6 13.5523 6.44771 14 7 14C7.55228 14 8 13.5523 8 13V12C8 10.3431 9.34315 9 11 9H12V9.68235C12 10.2253 12.6198 10.5351 13.0541 10.2094L16 8L13.0541 5.79059Z'
  ]
}

const faBCSettings = {
  prefix: 'fas',
  iconName: 'bc-settings',
  icon: [
    24,
    24,
    [],
    'f020',
    'M19.3518 9.54535L19.2567 9.51074L18.8851 8.60539L18.9254 8.51236C20.051 5.9065 19.9734 5.82877 19.7867 5.63985L18.2853 4.14471C18.2239 4.08255 18.1161 4.03882 18.0232 4.03882C17.9387 4.03882 17.6828 4.03882 15.4653 5.06403L15.3764 5.10477L14.4615 4.7287L14.4248 4.63573C13.382 2 13.2752 2 13.0157 2H10.8953C10.6368 2 10.5191 2 9.5521 4.64031L9.5157 4.73643L8.60557 5.11515L8.51855 5.07822C7.0176 4.43229 6.14122 4.10474 5.91277 4.10474C5.82007 4.10474 5.7119 4.14719 5.65025 4.20919L4.14741 5.70864C3.95677 5.90059 3.87769 5.98098 5.06225 8.53246L5.10578 8.62708L4.73363 9.53144L4.64255 9.56738C2 10.6098 2 10.7115 2 10.983V13.1039C2 13.3762 2 13.4892 4.6478 14.4578L4.74245 14.492L5.11465 15.3937L5.07468 15.4858C3.94909 18.0929 4.02048 18.1635 4.2121 18.358L5.71126 19.8552C5.7741 19.9168 5.88286 19.9609 5.97562 19.9609C6.05956 19.9609 6.31483 19.9609 8.5338 18.9362L8.62266 18.8937L9.53814 19.2717L9.57373 19.3652C10.6172 22 10.7244 22 10.984 22H13.105C13.3714 22 13.4818 22 14.4495 19.3579L14.4856 19.2618L15.3972 18.8856L15.4839 18.9217C16.9836 19.5694 17.8596 19.8963 18.0866 19.8963C18.1785 19.8963 18.2876 19.8552 18.3503 19.7918L19.8556 18.2891C20.0449 18.0962 20.1238 18.0173 18.9372 15.4682L18.893 15.3725L19.2645 14.472L19.3532 14.4365C22 13.3886 22 13.2865 22 13.0147V10.895C21.9999 10.6228 21.9999 10.5104 19.3518 9.54535ZM11.9999 15.4398C10.1049 15.4398 8.56333 13.8963 8.56333 12.0004C8.56333 10.1044 10.105 8.56293 11.9999 8.56293C13.8941 8.56293 15.4355 10.1048 15.4355 12.0004C15.4355 13.8959 13.8942 15.4398 11.9999 15.4398Z'
  ]
}

const faBCChurch = {
  prefix: 'fas',
  iconName: 'bc-church',
  icon: [
    24,
    24,
    [],
    'f021',
    'M4.55185 8.52686C4.44688 8.52686 4.36099 8.61819 4.36099 8.72982V11.0613C4.36099 11.173 4.27511 11.2643 4.17014 11.2643H2.40472C2.29975 11.2643 2.21387 11.3556 2.21387 11.4672V11.9823C2.21387 12.0939 2.29975 12.1852 2.40472 12.1852L4.17014 12.1776C4.27511 12.1776 4.36099 12.2689 4.36099 12.3806V18.8271C4.36099 18.9387 4.44688 19.0301 4.55185 19.0326L5.03614 19.0377C5.14111 19.0402 5.227 18.9489 5.227 18.8372V12.3907C5.227 12.2791 5.31288 12.1878 5.41785 12.1878L7.17372 12.1801C7.27869 12.1801 7.36458 12.0888 7.36458 11.9772V11.4698C7.36458 11.3582 7.27869 11.2668 7.17372 11.2668H5.40831C5.30334 11.2668 5.21745 11.1755 5.21745 11.0639L5.22461 8.73235C5.22461 8.62072 5.13873 8.52939 5.03376 8.52939H4.55185V8.52686Z M0.298266 7.62121C0.13604 7.76328 0.00244141 8.06011 0.00244141 8.28336V23.5941C0.00244141 23.8174 0.174211 24.0001 0.384151 24.0001H8.79608C9.00602 24.0001 9.17779 23.8174 9.17779 23.5941L9.18495 0.225857C9.18495 0.00260079 9.05373 -0.0633612 8.89151 0.0787107L0.298266 7.62121ZM7.98256 12.5633C7.98256 12.7865 7.81079 12.9692 7.60085 12.9717L6.37699 12.9768C6.16705 12.9768 5.99528 13.162 5.99528 13.3853V19.2381C5.99528 19.4614 5.82351 19.6415 5.61357 19.639L3.97461 19.6187C3.76467 19.6161 3.5929 19.4309 3.5929 19.2077V13.3777C3.5929 13.1544 3.42113 12.9717 3.21119 12.9743L1.98017 12.9768C1.77023 12.9768 1.59847 12.7967 1.59847 12.5734V10.8305C1.59847 10.6073 1.77023 10.4246 1.98017 10.4246H3.21119C3.42113 10.4246 3.5929 10.2419 3.5929 10.0187V8.2859C3.5929 8.06264 3.76467 7.87998 3.97461 7.87998H5.61357C5.82351 7.87998 5.99528 8.06264 5.99528 8.2859L5.99051 10.0187C5.99051 10.2419 6.16228 10.4246 6.37222 10.4246H7.60324C7.81318 10.4246 7.98495 10.6073 7.98495 10.8305V12.5633H7.98256Z M23.9975 12.2283C23.9975 12.005 23.8329 11.7691 23.6325 11.7031L10.3443 7.38771C10.1439 7.32175 9.97925 7.45114 9.97925 7.67439V23.594C9.97925 23.8173 10.151 23.9999 10.361 23.9999H23.6182C23.8281 23.9999 23.9999 23.8173 23.9999 23.594L23.9975 12.2283ZM14.054 20.9657C14.054 21.1889 13.8822 21.3716 13.6723 21.3716H13.355C13.145 21.3716 12.9733 21.1889 12.9733 20.9657V14.2503C12.9733 14.027 13.145 13.8443 13.355 13.8443H13.6723C13.8822 13.8443 14.054 14.027 14.054 14.2503V20.9657ZM15.9673 20.9657C15.9673 21.1889 15.7955 21.3716 15.5856 21.3716H15.2683C15.0584 21.3716 14.8866 21.1889 14.8866 20.9657V14.2503C14.8866 14.027 15.0584 13.8443 15.2683 13.8443H15.5856C15.7955 13.8443 15.9673 14.027 15.9673 14.2503V20.9657ZM19.2428 20.9657C19.2428 21.1889 19.0711 21.3716 18.8611 21.3716H18.5438C18.3339 21.3716 18.1621 21.1889 18.1621 20.9657V14.2503C18.1621 14.027 18.3339 13.8443 18.5438 13.8443H18.8611C19.0711 13.8443 19.2428 14.027 19.2428 14.2503V20.9657ZM21.1538 20.9657C21.1538 21.1889 20.982 21.3716 20.772 21.3716H20.4548C20.2448 21.3716 20.073 21.1889 20.073 20.9657V14.2503C20.073 14.027 20.2448 13.8443 20.4548 13.8443H20.772C20.982 13.8443 21.1538 14.027 21.1538 14.2503V20.9657Z'
  ]
}

const faBCMobileHome = {
  prefix: 'fas',
  iconName: 'bc-mobile-home',
  icon: [
    24,
    24,
    [],
    'f022',
    'M10.4643 8.85952C10.6738 8.85952 10.9952 8.77857 11.181 8.67857L16.0048 6.0619C16.1881 5.9619 16.4881 5.96429 16.6714 6.06667L21.3238 8.67381C21.5071 8.77619 21.8286 8.85952 22.0381 8.85952H22.9976C23.2071 8.85952 23.3786 8.6881 23.3786 8.47857V7.66429C23.3786 7.45476 23.2071 7.28333 22.9976 7.28333H22.45C22.2405 7.28333 21.919 7.2 21.7357 7.09762L16.6833 4.26429C16.5 4.16191 16.2 4.15952 16.0167 4.25952L10.781 7.1C10.5976 7.2 10.2738 7.28095 10.0643 7.28095H0.961905C0.752381 7.28095 0.580952 7.45238 0.580952 7.6619V8.47619C0.580952 8.68571 0.752381 8.85714 0.961905 8.85714L10.4643 8.85952Z M22.0905 10.1905C21.8809 10.1905 21.5595 10.1071 21.3762 10.0048L16.6476 7.40238C16.4643 7.30238 16.1643 7.3 15.9786 7.4L11.1619 10.0071C10.9786 10.1071 10.6548 10.1905 10.4452 10.1905H0.961905C0.752381 10.1905 0.571429 10.3595 0.571429 10.569V17.8524C0.571429 18.0619 0.752381 18.2381 0.961905 18.2381H14.0833C14.2929 18.2381 14.4762 18.0619 14.4762 17.8524V13.2786C14.4762 13.069 14.6357 12.9048 14.8452 12.9048H17.8429C18.0524 12.9048 18.2143 13.069 18.2143 13.2786V17.8524C18.2143 18.0619 18.3952 18.2381 18.6048 18.2381H22.9952C23.2048 18.2381 23.3809 18.0619 23.3809 17.8524V10.569C23.3809 10.3595 23.2048 10.1905 22.9952 10.1905H22.0905Z M4.00714 20.95C4.00714 21.0548 3.92143 21.1405 3.81667 21.1405H0.783333C0.678571 21.1405 0.592857 21.0548 0.592857 20.95V19.6833C0.592857 19.5786 0.678571 19.4929 0.783333 19.4929H3.81667C3.92143 19.4929 4.00714 19.5786 4.00714 19.6833V20.95Z M12.7214 20.95C12.7214 21.0548 12.6357 21.1405 12.531 21.1405H9.49762C9.39286 21.1405 9.30714 21.0548 9.30714 20.95V19.6833C9.30714 19.5786 9.39286 19.4929 9.49762 19.4929H12.531C12.6357 19.4929 12.7214 19.5786 12.7214 19.6833V20.95Z M23.3762 20.95C23.3762 21.0548 23.2905 21.1405 23.1857 21.1405H20.1524C20.0476 21.1405 19.9619 21.0548 19.9619 20.95V19.6833C19.9619 19.5786 20.0476 19.4929 20.1524 19.4929H23.1857C23.2905 19.4929 23.3762 19.5786 23.3762 19.6833V20.95Z'
  ]
}

const faBCRental = {
  prefix: 'fas',
  iconName: 'bc-rental',
  icon: [
    24,
    24,
    [],
    'f023',
    'M16.7905 0.961905C16.6476 0.809524 16.4119 0.809524 16.2667 0.961905L12.2095 5.25238C12.0667 5.40476 11.831 5.40476 11.6881 5.25L7.68095 0.964286C7.5381 0.811905 7.30238 0.809524 7.15952 0.961905L0.280952 8.23571C0.138095 8.38809 0.107143 8.65952 0.214286 8.84047L0.602381 9.49047C0.709524 9.67142 0.914286 9.69285 1.05952 9.54047L7.16191 3.08095C7.30476 2.92857 7.54048 2.92857 7.68333 3.08095L11.6952 7.36428C11.8381 7.51666 12.0738 7.51666 12.2167 7.36666L16.269 3.08095C16.4119 2.92857 16.6476  2.92857 16.7929 3.08095L22.8952 9.54047C23.0381 9.69285 23.2429 9.66904 23.3476 9.48809L23.7214 8.84285C23.8262 8.6619 23.7952 8.38809 23.65 8.23571L16.7905 0.961905Z M16.781 4.47381C16.6357 4.32143 16.4 4.32143 16.2572 4.47381L12.2191 8.72381C12.0738 8.87619 11.8381 8.87619 11.6952 8.72381L7.67143 4.47381C7.52858 4.32143 7.29048 4.32143 7.14762 4.47381L1.78095 10.1238C1.63571 10.2762 1.51905 10.5714 1.51905 10.781V23.6191C1.51905 23.8286 1.69048 24 1.9 24H5.30238C5.51191 24 5.68334 23.8286 5.68334 23.6191V19.5214C5.68334 19.3119 5.85476 19.1405 6.06429 19.1405H8.73572C8.94524 19.1405 9.11667 19.3119 9.11667 19.5214V23.6191C9.11667 23.8286 9.2881 24 9.49762 24H14.4333C14.6429 24 14.8143 23.8286 14.8143 23.6191V19.5214C14.8143 19.3119 14.9857 19.1405 15.1952 19.1405H17.8667C18.0762 19.1405 18.2476 19.3119 18.2476 19.5214V23.6191C18.2476 23.8286 18.4191 24 18.6286 24H22.031C22.2405 24 22.4119 23.8286 22.4119 23.6191V10.781C22.4119 10.5714 22.2929 10.2762 22.15 10.1238L16.781 4.47381Z M6.05476 9.78095H8.74523V13.3643H6.05476V9.78095ZM15.2619 9.78095H17.8047V13.3643H15.2619V9.78095Z'
  ]
}

const faBCBusiness = {
  prefix: 'fas',
  iconName: 'bc-business',
  icon: [
    24,
    24,
    [],
    'f024',
    'M21.12 9.44727C20.304 9.48 19.512 8.95637 19.008 8.07273C17.856 9.80728 15.912 9.90546 14.64 8.36728C14.544 8.23637 14.448 8.10545 14.352 7.94182C13.272 9.74182 11.328 9.97091 10.008 8.49818C9.86401 8.33455 9.72001 8.13818 9.60001 7.94182C9.00001 8.89091 8.13601 9.48 7.22401 9.48C6.24001 9.48 5.32801 8.89091 4.68001 7.87637C4.10401 8.76 3.31201 9.31636 2.44801 9.44727V23.5855H14.616V14.6836H18.528V23.5855H21.576V9.41454C21.12 9.44727 21.24 9.44727 21.12 9.44727ZM11.136 15.8945H5.496V11.1491H11.136V15.8945V15.8945ZM23.256 1.06909C23.496 1.03636 23.712 1.29819 23.736 1.62546C23.736 1.65818 23.736 1.65819 23.736 1.69092V5.38909C23.712 7.05818 22.824 8.46546 21.624 8.72728C20.328 8.92364 19.176 7.64728 19.032 5.88C19.032 5.74909 19.008 5.65091 19.008 5.52C19.008 7.28727 17.952 8.72728 16.656 8.72728C15.36 8.72728 14.304 7.28727 14.304 5.52C14.304 7.28727 13.248 8.72728 11.952 8.72728C10.656 8.72728 9.60001 7.28727 9.60001 5.52C9.60001 7.28727 8.54401 8.72728 7.24801 8.72728C5.95201 8.72728 4.896 7.28727 4.896 5.52C4.896 7.28727 3.84001 8.72728 2.54401 8.72728C2.44801 8.72728 2.376 8.72728 2.28 8.69455C1.08 8.4 0.216003 6.99273 0.216003 5.32364V1.65819C0.216003 1.33091 0.408008 1.06909 0.648008 1.06909C0.672008 1.06909 0.672003 1.06909 0.696003 1.06909H23.256V1.06909Z'
  ]
}

const faBCCommerical = {
  prefix: 'fas',
  iconName: 'bc-commercial',
  icon: [
    24,
    24,
    [],
    'f025',
    'M19.3882 3.77476H9.31765V6.61747H4.11765V0.116505H19.3882V3.77476V3.77476ZM9.31765 8.34174V23.8835H0V8.34174H9.31765ZM3.92941 19.0835H2.16471V20.5748H3.92941V19.0835ZM3.92941 16.5204H2.16471V18.0116H3.92941V16.5204ZM3.92941 13.934H2.16471V15.4252H3.92941V13.934ZM3.92941 11.3709H2.16471V12.8621H3.92941V11.3709ZM7.15294 19.0835H5.38823V20.5748H7.15294V19.0835ZM7.15294 16.5204H5.38823V18.0116H7.15294V16.5204ZM7.15294 13.934H5.38823V15.4252H7.15294V13.934ZM7.15294 11.3709H5.38823V12.8621H7.15294V11.3709ZM24 5.35922V23.8835H20.7294V18.2913H18.1176V23.8835H17.2471V18.2913H14.6118V23.8835H11.3412V5.35922H24ZM16.7294 11.8369H14.4235V13.7709H16.7294V11.8369ZM16.7294 8.50485H14.4235V10.4388H16.7294V8.50485ZM20.8941 11.8369H18.5882V13.7709H20.8941V11.8369ZM20.8941 8.50485H18.5882V10.4388H20.8941V8.50485Z'
  ]
}

export default [
  faBCContacts,
  faBCData,
  faBCWorkflow,
  faBCDocuments,
  faBCUsers,
  faBCAllModules,
  faBCSidebarToggle,
  faBCThreeBars,
  faBCTwoBars,
  faBCHExpand,
  faBCHCollapse,
  faBCAccess,
  faBCClaims,
  faBCDashboard,
  faBCIntegrations,
  faBCLines,
  faBCNotes,
  faBCPolicies,
  faBCQuote,
  faBCRules,
  faBCSettings,
  faBCChurch,
  faBCMobileHome,
  faBCRental,
  faBCBusiness,
  faBCCommerical
]
